"use client";

import { Hourglass, LogOut } from "lucide-react";

import { Button } from "@/components/ui/button";
import { signOut } from "@/lib/auth/api";

export function PendingApproval({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <section className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-xs">
        <Hourglass className="mx-auto mb-4 size-10 text-primary" />
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          {description}
        </p>
        <Button
          className="mt-6"
          variant="outline"
          onClick={async () => {
            await signOut();
            window.location.assign("/login");
          }}
        >
          <LogOut className="size-4" />
          Kijelentkezés
        </Button>
      </section>
    </div>
  );
}
